module.exports = __webpack_public_path__ + "img/SCGP_Master Logo_Primary Logo-01.81e98275.png";